<template>
    <div class="briefPage">
        <!-- 375*200 -->
        <div class="imgVideo">  
            <img v-if="getFileType(indoorBrief.img) === 'image'" :src="URL + indoorBrief.img " style="width: 100%; height: 100%" alt>
            <video v-if="getFileType(indoorBrief.img) === 'video'" :src="URL + indoorBrief.img" width="100%" height="100%"  controls="controls" poster="posterimage.jpg"></video>
            <!-- <div class="videoArea">
                <video ref="videoPlayer" class="video-js"></video>
            </div> -->
        </div>
        <div class="neirong">
            <div class="neirongCEN">
                <div class="neirongICON">
                    <img class="images" src="../assets/dizhi.png" alt="">
                </div>
                <div class="neirongXX">
                    {{indoorBrief.address}}
                </div>
            </div>
            <div class="neirongCEN">
                <div class="neirongICON">
                    <img class="images" src="../assets/time.png" alt="">
                </div>
                <div class="neirongXX">
                    {{indoorBrief.start_time}} --- {{indoorBrief.end_time}}
                </div>
            </div>
            <div class="neirongCEN" @click="makingCall">
                <div class="neirongICON">
                    <img class="images" src="../assets/mobile.png" alt="">
                </div>
                <div class="neirongXX">
                    {{indoorBrief.mobile}}
                </div>
            </div>
            <div class="details" v-html="indoorBrief.content">
            </div>
        </div>
        
    </div>
</template>
<script>
import videojs from 'video.js';
export default {
    name: 'brief',
    data() {
        return {
            indoorBrief:'',
            URL: process.env.BASE_IMG_API,
            player: null
        };
    },
  
    mounted() {
        console.log(this.$route.query.indoorInformation,'打印this.$route.query.indoorInformation')
        this.indoorBrief = this.$route.query.indoorInformation
        this.createVideo()
    },
    methods: {
        createVideo(){
            let options = {
                    autoplay: false,
                    controls: true,
                    sources: [
                        {
                            src: `${this.URL}${this.indoorBrief.img}`,
                        }
                    ]
                }
            this.player = videojs(this.$refs.videoPlayer, options, function onPlayerReady() {
                console.log('onPlayerReady', this);
            })
        },
        makingCall(){
            window.location.href = 'tel://' + this.indoorBrief.mobile
        },
        getFileType(name) {
                // 判断类型
                if (!name) return false;
                const imgType = ["gif", "jpeg", "jpg", "bmp", "png"];
                var videoType = [
                    "avi",
                    "wmv",
                    "mkv",
                    "mp4",
                    "mov",
                    "rm",
                    "3gp",
                    "flv",
                    "mpg",
                    "rmvb",
                    "m3u8",
                    "webm"
                ];
                if (
                    RegExp(".(" + imgType.join("|") + ")$", "i").test(name.toLowerCase())
                ) {
                    return "image";
                } else if (
                    RegExp(".(" + videoType.join("|") + ")$", "i").test(name.toLowerCase())
                ) {
                    return "video";
                } else {
                    return false;
                }
        },
    },
};
</script>
<style scoped lang="scss">
.briefPage{
    width: 100%;
    height: 100%;
    font-size: 0.14rem;
  
    .imgVideo{
        width: 100%;
        height: 2rem;
        background:white;
    }
    .neirong{
        width: 100%;
        box-sizing: border-box;
        padding: 0.2rem;
        .neirongCEN{
            width: 100%;
            height: 0.2rem;
            margin-bottom: 0.1rem;
            display: flex;
            .neirongICON{
                width: 0.2rem;
                height: 0.2rem;
                .images{
                    width: 100%;
                    height: 100%;
                }
            }
            .neirongXX{
                font-size: 0.18rem;
                flex: 1;
                height: 0.2rem;
                color:rgb(79, 78, 78) ;
                margin-left: 0.1rem;
            }
        }
        .details{
            margin-top: 0.2rem;
            width: 100%;
            font-size: 0.2rem;
            color: #707070;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/brief.vue